import { parseISO } from 'date-fns';
import { format } from 'date-fns-tz';
import { ptBR } from 'date-fns/locale';
import { DateFormats } from 'helpers/enums/DateTypes';
import moment from 'moment';

export const TIME_ZONE_SP: string = 'America/Sao_Paulo';

export const getFormatedDateTime = (
  date: any,
  newFormat: DateFormats | DateFormats.DateTime
): string => {
  return format(date, newFormat, {
    timeZone: TIME_ZONE_SP,
    locale: ptBR,
  });
};

export const getDate = (date: string | number | Date): string => {
  return getFormatedDateTime(date, DateFormats.Date);
};

export const getTime = (date: string | number | Date): string => {
  return getFormatedDateTime(date, DateFormats.Time);
};

export const getDateFullTime = (date: string | number | Date): string => {
  return getFormatedDateTime(date, DateFormats.DateFullTime);
};

export const isAValidDate = (ISODate: string) => {
  const parsed = parseISO(ISODate);
  return parsed instanceof Date && !isNaN(parsed.valueOf());
};

export const localeDateToISO = (localeDate: string | any) => {
  if (localeDate === null) {
    const date = new Date();
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
  }
  return localeDate!?.split('/').reverse().join('-');
};
export const ISOToLocaleDate = (localeDate: string) => {
  return localeDate.split('-').reverse().join('/');
};

export const addSomeDaysToDate = (date: string | any, days: number) => {
  const formatedDate = localeDateToISO(date);
  const newDate = new Date(formatedDate);
  newDate.setDate(newDate.getDate() + days);
  return newDate;
};

export const dateIsGreaterThan = (date1: string, date2: string) => {
  const dateA = new Date(localeDateToISO(date1));
  const dateB = new Date(localeDateToISO(date2));

  if (dateA > dateB) {
    return true;
  }

  return false;
};

export const isDateGreaterThanToday = (date: Date | string): boolean => {
  const today = new Date();
  const formattedDate = moment(date).format('DD/MM/YYYY');

  if (date instanceof Date) {
    return date > today;
  }

  return new Date(formattedDate) > today;
};

export const isDateLessThanToday = (date: Date | string): boolean => {
  const today = new Date();
  const formattedDate = moment(date).format('DD/MM/YYYY');

  if (date instanceof Date) {
    return date < today;
  }

  return new Date(formattedDate) < today;
};

export const createDateFromTextValue = (value: string) => {
  const year = new Date().getFullYear();
  if (value.length < 3) {
    return new Date(year, 1, 1, parseInt('00'), parseInt('00'));
  }
  const splitParts = value.split(':');

  return new Date(year, 1, 1, parseInt(splitParts[0]), parseInt(splitParts[1]));
};

export const isCorrectDate = (date: Date | string): boolean => {
  if (date instanceof Date) {
    return date instanceof Date && isFinite(+date);
  }

  return new Date(date) instanceof Date && isFinite(+date);
};

export const getHoursAndDate = (date: Date) => {
  const minutes = date.getMinutes();
  const hour = date.getHours();

  return `${hour === 0 ? '00' : hour >= 1 && hour <= 9 ? `0${hour}` : hour}:${
    minutes === 0
      ? '00'
      : minutes >= 1 && minutes <= 9
      ? `0${minutes}`
      : minutes
  }`;
};
